import React, { useState } from "react";
import { es } from "react-date-range/dist/locale/index";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRange } from "react-date-range";

interface DateSelectorProps {
  startDay?: Date | null;
  endDay?: Date | null;
  onChange?: (startDate: Date, endDate: Date) => void;
  maxDate?: Date;
}

const DateSelector: React.FC<DateSelectorProps> = ({
  startDay,
  endDay,
  onChange,
  maxDate,
}) => {
  const [ranges, setRanges] = useState([
    {
      startDate: startDay ? startDay : new Date(),
      endDate: endDay ? endDay : new Date(),
      key: "selection",
    },
  ]);

  const handleChange = (item: any) => {
    setRanges([item.selection]);
    if (onChange) onChange(item.selection.startDate, item.selection.endDate);
  };

  return (
    <DateRange
      showDateDisplay={false}
      ranges={ranges}
      onChange={handleChange}
      moveRangeOnFirstSelection={false}
      locale={es}
      maxDate={maxDate}
    />
  );
};
export default DateSelector;
